module.exports = __webpack_public_path__ + "img/closed.b15ae9c5.svg";